import React, { useState, useEffect, Fragment } from 'react';
import { API, Storage } from 'aws-amplify';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link, withRouter, useLocation } from "react-router-dom";
import queryString from 'query-string';
import {
    Baseball,
    Basketball,
    Football,
    Golf,
    Lacrosse,
    Soccer,
    Softball,
    Swimming,
    Volleyball,
    Wrestling
} from '../images/icons';

import { listEvents } from '../graphql/queries';
import { sports } from '../enum/sports';
import { states } from '../enum/states';

//material ui-theme - move to central location
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: 'white'
    },
}));



function Events() {
    let params = queryString.parse(useLocation().search);
    const [events, setEvents] = useState([]);
    const [searchTerm, setSearchTerm] = useState(params.search ? params.search : '');
    const [sportSearchTerm, setSportSearchTerm] = useState(params.sport ? params.sport : '');
    const [stateSearchTerm, setStateSearchTerm] = useState(params.state ? params.state : '');
    const classes = useStyles();

    function toggle24hr(time, onoff) {
        if (onoff === undefined) onoff = isNaN(time.replace(':', ''))//auto-detect format
        var pm = time.toString().toLowerCase().indexOf('pm') > -1 //check if 'pm' exists in the time string
        time = time.toString().toLowerCase().replace(/[ap]m/, '').split(':') //convert time to an array of numbers
        time[0] = Number(time[0])
        if (onoff) {//convert to 24 hour:
            if ((pm && time[0] !== 12)) time[0] += 12
            else if (!pm && time[0] === 12) time[0] = '00'  //handle midnight
            if (String(time[0]).length === 1) time[0] = '0' + time[0] //add leading zeros if needed
        } else { //convert to 12 hour:
            pm = time[0] >= 12
            if (!time[0]) time[0] = 12 //handle midnight
            else if (pm && time[0] !== 12) time[0] -= 12
        }
        return onoff ? time.join(':') : time.join(':') + (pm ? 'pm' : 'am')
    }

    const generateDate = (d) => {
        let date = new Date(d);
        let month = date.toLocaleString('default', { month: 'short' });
        let day = date.getDate();
        let year = date.getFullYear();
        return {
            month: month,
            day: day,
            year: year
        }
    };

    //input handlers
    const handleSearchChange = e => {
        setSearchTerm(e.target.value);
    };

    const handleStateChange = e => {
        setStateSearchTerm(e.target.value);
    };

    const handleSportChange = e => {
        setSportSearchTerm(e.target.value);
    };

    const getSportsImage = (sport) => {

        switch (sport) {
            case 'soccer':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Soccer Icon" href={Soccer} />
                );
            case 'baseball':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Baseball Icon" href={Baseball} />
                );
            case 'basketball':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Basketball Icon" href={Basketball} />
                );
            case 'football':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Football Icon" href={Football} />
                );
            case 'golf':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Golf Icon" href={Golf} />
                );
            case 'lacrosse':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Lacrosse Icon" href={Lacrosse} />
                );
            case 'softball':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Softball Icon" href={Softball} />
                );
            case 'swimming':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Swimming Icon" href={Swimming} />
                );
            case 'volleyball':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Volleyball Icon" href={Volleyball} />
                );
            case 'wrestling':
                return (
                    <image x="10" y="6" height="40" width="40" alt="Wrestling Icon" href={Wrestling} />
                );

            default:
                return;
        }

    };

    //fetch filtered events 
    //TODO: move to api area
    //TODO: build search query to replace this function which filters client side (optimization gain, no functionality gain)
    const fetchFilteredEvents = async (searchTerm, sportSearchTerm, stateSearchTerm) => {
        const apiData = await API.graphql({ query: listEvents });
        const eventsFromAPI = apiData.data.listEvents.items;

        await Promise.all(eventsFromAPI.map(async event => {
            //check for and grab banner image
            if (event.bannerImage) {
                const bannerImage = await Storage.get(event.bannerImage);
                event.bannerImage = bannerImage;
            }
            //check for and grab athlete image
            if (event.athleteImage) {
                const athleteImage = await Storage.get(event.athleteImage);
                event.athleteImage = athleteImage;
            }

            const dispStartDate = generateDate(event.startDate);
            const dispeEndDate = generateDate(event.endDate);

            event.dispStartDate = dispStartDate;
            event.dispeEndDate = dispeEndDate;

            return event;
        }));


        //filter events based on keywords (checks both event name & athlete name)
        var results = apiData.data.listEvents.items.filter(events => {
            if (events.name.toLowerCase().includes(searchTerm) || events.athleteName.toLowerCase().includes(searchTerm))
                return true;
            else
                return false;
        });

        //filter by sport
        if (sportSearchTerm !== "") {
            results = results.filter(events => {
                if (events.sport !== null) {
                    return events.sport.toLowerCase().includes(sportSearchTerm);
                }
                return false;
            })
        }

        //filter by state
        if (stateSearchTerm !== "") {
            results = results.filter(events => {
                if (events.state !== null) {
                    return events.state.toLowerCase().includes(stateSearchTerm);
                }
                return false;
            })
        }

        setEvents(results);
    }

    //watch for changes to search terms
    useEffect(() => {
        fetchFilteredEvents(searchTerm, sportSearchTerm, stateSearchTerm)
    });

    return (
        <div className="events">
            <div className="container pt-5">
                <h1 className="mx-auto">EVENTS</h1>
            </div>
            <div className="container-fluid  mt-3">
                <p className="mx-auto mb-3">Use the search below to find upcoming events near you!</p>
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <FormControl variant="outlined" fullWidth className={classes.formControl}>
                            <InputLabel shrink >Search Field</InputLabel>
                            <TextField
                                placeholder="Search by event and athlete name"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                variant="outlined"
                                className={classes.textField}
                            />
                        </FormControl>
                    </div>
                    <div className="col">
                        <FormControl variant="outlined" fullWidth className={classes.formControl}>
                            <InputLabel shrink >Sport</InputLabel>
                            <Select
                                value={sportSearchTerm}
                                onChange={handleSportChange}
                                className={classes.selectEmpty}
                            >
                                <MenuItem value=""><em>Any</em></MenuItem>
                                {Object.keys(sports).map(key => (
                                    <MenuItem value={key}>{sports[key].name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col">
                        <FormControl variant="outlined" fullWidth className={classes.formControl}>
                            <InputLabel shrink >State</InputLabel>
                            <Select
                                value={stateSearchTerm}
                                onChange={handleStateChange}
                                className={classes.selectEmpty}
                            >
                                <MenuItem value=""><em>None</em></MenuItem>
                                {Object.keys(states).map(key => (
                                    <MenuItem value={key}>{states[key].name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className=" mt-3 card-columns ">
                {
                    events.map(event => (
                        <Fragment>
                            {new Date(event.endDate) >= new Date() ?
                                <div key={event.id || event.name} className="card mt-2 mb-2">
                                    <div className="img-overlay-wrap">
                                        <img src={event.bannerImage} alt={event.name + " Banner Image"} />
                                        <svg className="banner-svg" viewBox="0 0 355 52" fill="#F1A54C" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M302.068 52L355 0H-8V52H302.068Z" fill="#F1A54C" />
                                            {getSportsImage(event.sport)}
                                            <text x="60" y="25" fill="white" style={{ font: '24px Roboto', textTransform: 'uppercase' }} >{event.athleteName}</text>
                                            <text x="60" y="45" fill="white" style={{ font: '18px "Open Sans"' }}>{event.name}</text>
                                        </svg>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="row pl-2 pr-2 mb-3">
                                                    <div className="col my-auto">
                                                        <div className="row">
                                                            <h2>{event.dispStartDate.month}</h2>
                                                        </div>
                                                        <div className="row">
                                                            <h1>{event.dispStartDate.day}</h1>
                                                        </div>
                                                    </div>
                                                    <div className="col my-auto">
                                                        <h1> - </h1>
                                                    </div>
                                                    <div className="col my-auto">
                                                        <div className="row">
                                                            <h2>{event.dispeEndDate.month}</h2>
                                                        </div>
                                                        <div className="row">
                                                            <h1>{event.dispeEndDate.day}</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-6 my-auto">
                                                <div className="row">
                                                    <p className='mx-auto'>{event.city}, {states[event.state].name}</p>
                                                </div>
                                                <div className="row">
                                                    <p className="mx-auto">{toggle24hr(event.startTime)} - {toggle24hr(event.endTime)}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <Link className="" to={'/' + event.slug}>
                                            <div className="btn btn-primary d-flex">
                                                <div className="btn-text row justify-content-center align-self-center mx-auto">LEARN MORE</div>
                                            </div>
                                        </Link>

                                    </div>
                                </div> :
                                null

                            }
                        </Fragment>
                    ))
                }
            </div>
        </div>
    );
}

export default withRouter(Events);


